import { Suspense } from 'react';
import { VPThemeProvider } from '@visionplanner/ui-react-material';
import BusyIndicator from '../common/busy-indicator-provider/busy-indicator';
import { NotificationProvider } from '../common/notification-provider/notification-provider';
import BusyIndicatorContextProvider from '../common/busy-indicator-provider/busy-indicator-context';
import { ApplicationAsyncCallbackMiddlewareProvider } from './application-async-callback-middleware-provider';
import ModalDialogContainer from '../common/modal-dialog/modal-dialog-container';
import modalDialogList from '../common/modal-dialog/modal-dialog-list';
import ApplicationRoutes from '../config/routes';

const App = () => (
  <VPThemeProvider>
    <BusyIndicatorContextProvider>
      <NotificationProvider>
        <ApplicationAsyncCallbackMiddlewareProvider>
          <BusyIndicator />
          <Suspense fallback={<BusyIndicator />}>
            <ModalDialogContainer modalsList={modalDialogList}>
              <ApplicationRoutes />
            </ModalDialogContainer>
          </Suspense>
        </ApplicationAsyncCallbackMiddlewareProvider>
      </NotificationProvider>
    </BusyIndicatorContextProvider>
  </VPThemeProvider>
);

export default App;
